import { FC, useMemo } from 'react'
import { createFloatingPaneByTypeSelector } from 'selectors/floatingPanesSelectors'
import { useStoreSelector } from 'helpers/reactReduxHelpers'

import {
  CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_CHOOSE_CURRENCY,
  CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_ENABLE,
  CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_SENDING_REQUEST,
  CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_SUCCESS,
} from 'components/features/rewards/rewardsPane/constants/paneSteps'
import { FLOATING_PANE_AUTO_INVESTMENTS_MODE, FLOATING_PANE_CRYPTO_REWARDS_PANE_TYPE } from 'components/features/rewards/rewardsPane/constants/paneState'
import { CryptoRewardsPane } from 'components/features/rewards/rewardsPane/types/paneState'
import {
  CryptoRewardsAutoInvestmentsSendingRequestStep,
} from 'components/features/rewards/rewardsPane/containers/CryptoRewardsAutoInvestmentsPane/CryptoRewardsAutoInvestmentsSendingRequestStep/CryptoRewardsAutoInvestmentsSendingRequestStep'
import {
  CryptoRewardsAutoInvestmentsCurrencyChoosingStep,
} from 'components/features/rewards/rewardsPane/containers/CryptoRewardsAutoInvestmentsPane/CryptoRewardsAutoInvestmentsCurrencyChoosingStep/CryptoRewardsAutoInvestmentsCurrencyChoosingStep'
import {
  CryptoRewardsAutoInvestmentSuccessStep,
} from 'components/features/rewards/rewardsPane/containers/CryptoRewardsAutoInvestmentsPane/CryptoRewardsAutoInvestmentSuccessStep/CryptoRewardsAutoInvestmentSuccessStep'
import {
  CryptoRewardsAutoInvestmentsEnableStep,
} from 'components/features/rewards/rewardsPane/containers/CryptoRewardsAutoInvestmentsPane/CryptoRewardsAutoInvestmentsEnableStep/CryptoRewardsAutoInvestmentsEnableStep'

type CryptoRewardsAutoInvestmentsPaneProps = {
  onClose: () => void
}
export const CryptoRewardsAutoInvestmentsPane: FC<CryptoRewardsAutoInvestmentsPaneProps> = ({ onClose }) => {
  const paneSelector = useMemo(createFloatingPaneByTypeSelector, [])
  const pane = useStoreSelector((state) => paneSelector(state, FLOATING_PANE_CRYPTO_REWARDS_PANE_TYPE)) as Extract<CryptoRewardsPane, { mode: typeof FLOATING_PANE_AUTO_INVESTMENTS_MODE }> | null

  if (!pane) {
    return null
  }

  switch (pane.step) {
    case CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_ENABLE:
      return (
        <CryptoRewardsAutoInvestmentsEnableStep onClose={ onClose } />
      )
    case CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_CHOOSE_CURRENCY:
      return (
        <CryptoRewardsAutoInvestmentsCurrencyChoosingStep onClose={ onClose } />
      )
    case CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_SENDING_REQUEST:
      return <CryptoRewardsAutoInvestmentsSendingRequestStep onClose={ onClose } />
    case CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_SUCCESS:
      return <CryptoRewardsAutoInvestmentSuccessStep onClose={ onClose } />
  }

  return null
}
